var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-empty-state',{attrs:{"title":_vm.$options.i18n.title,"svg-path":_vm.groupsEmptyStateIllustration,"svg-height":null}})
}
var staticRenderFns = []

export { render, staticRenderFns }